export type IProcessLinkedAutoDates = ($input: JQuery<HTMLInputElement>, suffix?: string) => void;

export function _processLinkedAutoDates($input: JQuery<HTMLInputElement>, suffix?: string): void {
  ($ as any).log(`_processLinkedAutoDates: FIRE`);

  const startDateIdent = $input.data('start-date-ident');
  const unitDateIdent = $input.data('unit-date-ident');
  const unitDateIdentArr = unitDateIdent.split(',');
  const endDateIdent = $input.data('end-date-ident');
  const _fieldSuffix = suffix || window.fieldSuffix;

  let startDateSelector: string;
  let unitDateSelector: string;
  let unitDateSelectorFound = false;
  let unitDateValue: number;
  let unitDateNameSelector: string | undefined;
  let endDateSelector: string;
  let $startDateInput: JQuery<HTMLInputElement> | any;
  let $unitDateInput: JQuery<HTMLInputElement> | any;
  let $unitDateInputs: JQuery<HTMLInputElement> | any;
  let $endDateInput: JQuery<HTMLInputElement> | any;
  let unitDateInputType: string;
  let unitDateInputValue;
  let unit = 'day';
  let endDateValueNew;
  let endDateValueDisplay;
  let endDateValueDay;
  let enabledDaysArray: number[];
  let highInDaysArray;
  let daysToSubtract = 0;
  let differenceBetweenDates;
  let adjustEndDate: IDCA.IGenericObj | undefined;

  // Setup needed dom elements, start date, unit and end date
  function setInputs() {
    const startDateSelectorCache = $input.data('start-date-selector') || false;
    const endDateSelectorCache = $input.data('end-date-selector') || false;
    const unitDateSelectorCache = $input.data('unit-date-selector') || false;
    const unitDateNameSelectorCache = $input.data('unit-date-name-selector') || false;
    // Get selectors
    if (startDateSelectorCache && endDateSelectorCache) {
      startDateSelector = startDateSelectorCache;
      endDateSelector = endDateSelectorCache;
    } else {
      // Loop over fields array and find selectors for the three inputs we need
      $.each(window.fields, (_, obj) => {
        if (obj.identifier === startDateIdent) {
          startDateSelector = `#field_${obj.id}${_fieldSuffix}`;
        }
        if (obj.identifier === endDateIdent) {
          endDateSelector = `#field_${obj.id}${_fieldSuffix}`;
        }
      });
    }

    if (unitDateSelectorCache) {
      unitDateSelector = unitDateSelectorCache;
      unitDateNameSelector = unitDateNameSelectorCache;
    } else {
      for (const _unitDateIdent of unitDateIdentArr) {
        /* eslint-disable no-loop-func */
        $.each(window.fields, (_, obj) => {
          if (obj.identifier === _unitDateIdent) {
            unitDateSelector = `#field_${obj.id}${_fieldSuffix}`;
            unitDateNameSelector = `input[name="field_${obj.id}${_fieldSuffix}"]`;
            const $temp = $(unitDateSelector);
            if ($temp.length && $temp.is(':visible')) {
              unitDateSelectorFound = true;
              return false;
            }
          }
          return true;
        });
        if (unitDateSelectorFound) {
          break;
        }
      }
    }

    // Put selectors in cache
    $input.data({
      'end-date-selector': endDateSelector,
      'start-date-selector': startDateSelector,
      'unit-date-name-selector': unitDateIdentArr.length === 1 ? unitDateNameSelector : false,
      'unit-date-selector': unitDateIdentArr.length === 1 ? unitDateSelector : false,
    });

    // Start date input, unit date input and end date input elements
    $startDateInput = $(startDateSelector);
    $endDateInput = $(endDateSelector);
    $unitDateInput = $(unitDateSelector);
  }

  // Set value into unit value input
  function setUnitValue(v: number) {
    const val = v.toString();
    if (unitDateInputType === 'text') {
      $unitDateInput.val(val);
    } else if (unitDateInputType === 'radio') {
      $unitDateInputs.each((_: number, radio: HTMLInputElement) => {
        const $radio = $(radio);
        const $label = $radio.closest('label');
        const labelText = $label.text().trim();
        $radio.prop('checked', labelText === val);
      });
    } else if (unitDateInputType === 'select-one') {
      unitDateInputValue = $unitDateInput.find('option:selected').text();
      $unitDateInput.find('option').each((_: number, option: HTMLOptionElement) => {
        const $option = $(option);
        const optionText = $option.text().trim();
        $option.prop('selected', optionText === val);
      });
    }
  }

  // Allow adjustemnt of end date input calculation
  function initEndDateAdjustment() {
    const endDateAdjustment = $unitDateInput.data('end-date-adjust') || false;
    if (endDateAdjustment) {
      const endDateAdjustmentArr = endDateAdjustment.split('|');
      adjustEndDate = {
        direction: endDateAdjustmentArr[0],
        quantity: endDateAdjustmentArr[2],
        unit: endDateAdjustmentArr[1],
      };
    }
  }

  setInputs();
  initEndDateAdjustment();

  // Datepicker instances
  const startDateInputDatepicker = $startDateInput.data('datepicker');
  const endDateInputDatepicker = $endDateInput.data('datepicker');

  // Define weekdays object
  const { weekdays } = startDateInputDatepicker;

  // *** UNIT RELATED CODE *** //
  // If unit input is a radio button, we need to select by name
  if ($unitDateInput.length === 0 && unitDateNameSelector) {
    $unitDateInputs = $(unitDateNameSelector);
    $unitDateInput = $unitDateInputs.first();
  }
  // Unit defaults to week unless specified in the unit input
  if (typeof $unitDateInput.data('date-unit') !== 'undefined') {
    unit = $unitDateInput.data('date-unit');
  }

  // Get the type of the unit input. Allowed: Text(number), Dropdown, Radio
  unitDateInputType = $unitDateInput[0].type;
  if (unitDateInputType === 'text') {
    unitDateInputValue = $unitDateInput.val();
  } else if (unitDateInputType === 'radio') {
    unitDateInputValue = $unitDateInputs.filter(':checked').closest('label').text().trim();
  } else if (unitDateInputType === 'select-one') {
    unitDateInputValue = $unitDateInput.find('option:selected').text();
  }
  // Convert the unit value into a number
  unitDateInputValue = Number(unitDateInputValue);

  // *** START DATE RELATED CODE *** //
  // Validate the start date. Can't be blank and must be a valid date
  const startDateValue = startDateInputDatepicker.getMomentOfValue();
  const startDateIsValid = !startDateValue.isEmpty() && startDateValue.isValid();

  const endDateValue = endDateInputDatepicker.getMomentOfValue();
  const endDateIsValid = !endDateValue.isEmpty() && endDateValue.isValid();

  // If end date is being modified, and both start and end date have a value, modify the unit
  if ($input.is($endDateInput) && startDateIsValid && endDateIsValid) {
    differenceBetweenDates = endDateValue.diff(startDateValue);
    if (differenceBetweenDates > 0) {
      switch (unit) {
        case 'day': {
          unitDateValue = parseFloat((differenceBetweenDates / (1000 * 60 * 60 * 24)).toString());
          break;
        }
        case 'week': {
          unitDateValue = parseFloat(
            (differenceBetweenDates / (1000 * 60 * 60 * 24 * 7)).toString()
          );
          // Round up on .9
          const unitDateValueArray = unitDateValue.toString().split('.');
          if (unitDateValueArray.length === 2 && unitDateValueArray[1] === '9') {
            unitDateValue = Math.round(unitDateValue);
          }
          break;
        }
        case 'month': {
          const preciseDiff = window.moment.preciseDiff(startDateValue, endDateValue, true);
          unitDateValue =
            preciseDiff.years * 12 +
            preciseDiff.months +
            parseFloat((preciseDiff.days / 30).toString());
          break;
        }
        case 'year': {
          const preciseDiff = window.moment.preciseDiff(startDateValue, endDateValue, true);
          unitDateValue = preciseDiff.years + parseFloat((preciseDiff.months / 12).toString());
          break;
        }
        default: {
          unitDateValue = parseFloat((differenceBetweenDates / (1000 * 60 * 60 * 24)).toString());
        }
      }
      setUnitValue(unitDateValue);
    }
  } else {
    // Check which days are allowed for the end date input. If no allowed days are specified all days will be allowed
    if (
      typeof $endDateInput.data('allowed-days') === 'undefined' ||
      $endDateInput.hasClass('ignore-days-restriction')
    ) {
      enabledDaysArray = [0, 1, 2, 3, 4, 5, 6];
    } else {
      enabledDaysArray = [];
      $.each($endDateInput.data('allowed-days').split(','), (_, value) => {
        const dayId = weekdays[value];
        enabledDaysArray.push(dayId);
      });
    }

    // Highest allowed date in endDateInput
    highInDaysArray = Math.max(...enabledDaysArray);

    // If the start date is valid, and the unit date is valid, we run the end date calculations
    if (
      startDateIsValid &&
      unitDateInputValue &&
      !Number.isNaN(Number(unitDateInputValue)) &&
      enabledDaysArray.length > 0
    ) {
      // End date after adding units
      endDateValueNew = window.window.moment(startDateValue);
      endDateValueNew = endDateValueNew.add(unitDateInputValue, unit);
      if (adjustEndDate) {
        endDateValueNew =
          adjustEndDate.direction === 'dec'
            ? endDateValueNew.subtract(adjustEndDate.quantity, adjustEndDate.unit)
            : endDateValueNew.add(adjustEndDate.quantity, adjustEndDate.unit);
      }
      // End date Day after adding units
      endDateValueDay = endDateValueNew.day();

      // If the endDate Day is not allowed inside the date picker, find the earliest allowed date
      if (enabledDaysArray.indexOf(endDateValueDay) === -1) {
        for (let i = 6; i >= 0; i -= 1) {
          daysToSubtract += 1;
          if (i === highInDaysArray) {
            break;
          }
        }
      }
      // Lower date to the lowest allowed date in the datepicker
      if (daysToSubtract !== 0) {
        endDateValueNew.subtract(daysToSubtract, 'days');
      }

      // Create end date display value
      endDateValueDisplay = endDateValueNew.formatWithJDF($endDateInput.data('date-time-format'));

      // Insert end date display value into the endDateInput
      $endDateInput.val(endDateValueDisplay);
      window.DexeroCoreApp.showFormGroupSuccess($endDateInput);
    }
  }
}
